import { createAction } from '@reduxjs/toolkit';
import { Scorecard, ScorecardsActionStoreArgument } from 'store/interfaces';

export const setFullData = createAction<{
  store: ScorecardsActionStoreArgument;
  data: Scorecard;
}>('scorecards/setFullData');
